export default __webpack_public_path__ + "static/media/pl_cod_08092564.c5885cb1.jpg";